import ApplicationAdapter from './application';
import { service } from '@ember/service';
// This is for types. Anything we have custom may show an error.
import type StoreService from 'ember-data/store';

interface PaymentArgs {
  companyId?: string;
  paymentId?: string;
}

export default class TasPaymentAdapter extends ApplicationAdapter {
  @service declare store: StoreService;

  async settlePayment({ paymentId }: PaymentArgs) {
    // @ts-expect-error: stop using adapters
    const url = [this.buildURL('tas-payment'), paymentId, 'settle_payment'].join('/');
    return this.ajax(url, 'PUT');
  }

  async cancelPayment({ paymentId }: PaymentArgs) {
    // @ts-expect-error: stop using adapters
    const url = [this.buildURL('tas-payment'), paymentId, 'cancel_payment'].join('/');
    return this.ajax(url, 'DELETE');
  }
}
